import React from 'react';
import { FiCheckCircle, FiAlertCircle, FiInfo, FiX } from 'react-icons/fi';
import { useToast } from '../../context/ToastContext';
import s from './Toast.module.css';

const ICONS = {
  success: <FiCheckCircle className={`${s.icon} ${s.iconSuccess}`} />,
  error: <FiAlertCircle className={`${s.icon} ${s.iconError}`} />,
  info: <FiInfo className={`${s.icon} ${s.iconInfo}`} />,
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className={s.container}>
      {toasts.map(t => (
        <div key={t.id} className={s.toast}>
          {ICONS[t.type] || ICONS.info}
          <span className={s.message}>{t.message}</span>
          <button className={s.close} onClick={() => removeToast(t.id)}>
            <FiX />
          </button>
        </div>
      ))}
    </div>
  );
}

